import { Shark, Utils, View } from "shark-mvc";

// import Client from "../../models/Client";

import templateContent from "./client-list.html";

import activeWorkSessionDisplayComponent from "../../components/activeWorkSessionDisplay/activeWorkSessionDisplayComponent";
// import clientDetailView from "./clientDetailView";
import clientDetailPanelComponent from "../../components/clientDetailPanel/clientDetailPanelComponent";
import clientManager from "../../managers/clientManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import systemComponent from "../../components/systemComponent";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import workSessionDetailsModalComponent from "../../components/workSessionDetailsModal/workSessionDetailsModalComponent";
import organizationUserDetailPanelComponent from "../../components/organizationUserDetailPanel/organizationUserDetailPanelComponent";

class ClientListView extends View {
	constructor () {
		super("clientListView");
		this.setTemplate(templateContent);
	}

	// addClientBtn_clickHandler () {
	// 	const { currOrganization } = Shark.get();

	// 	if (currOrganization && currOrganization.guid !== "") {
	// 		const currClient = new Client({
	// 			organizationGuid: currOrganization.guid,
	// 			status: 1,
	// 		});

	// 		Shark.set({currClient});
	// 		Shark.openPage(clientDetailView);
	// 	}
	// }

	async beforeLoad () {
		waitBoxComponent.open();

		this.updateMenuTitle();
		// const { organizationList, organizationMembershipList } = Shark.get();
		// console.log({ organizationList, organizationMembershipList })

		// if (!organizationList || !organizationMembershipList) {
		// await systemComponent.getWritableOrganizationList();
		// }

		// const { clientList } = Shark.get();

		// if (!clientList || clientList.length === 0) {
		this.refreshClientList();
		// }
		waitBoxComponent.close();
	}

	// editBtn_clickHandler (event, data) {
	// 	const currClient = Utils.safp(Shark.get("clientList"), "guid", data.guid);

	// 	if (currClient) {
	// 		Shark.set({currClient});
	// 		// Shark.openPage(clientDetailView, {urlSearchParams: { clig: currClient.guid }});
	// 	}
	// }

	filterClients (searchKey) {
		const { clientList } = Shark.get();
		let { filteredClientList } = Shark.get();
		let visibleItemCount = 0;

		// clientList.forEach(item => {
		// 	if (searchKey === "" || item.businessName.toLowerCase().includes(searchKey) || item.name.toLowerCase().includes(searchKey)) {
		// 		item.__cssClasses.delete("d-none");
		// 		visibleItemCount++;
		// 	}
		// 	else {
		// 		item.__cssClasses.add("d-none");
		// 	}
		// 	item.flattenCSSClasses();
		// });

		if (searchKey === "") {
			filteredClientList = clientList;
		}
		else {
			filteredClientList = clientList.filter(item => item.name.toLowerCase().includes(searchKey));
		}

		Utils.reindexList(filteredClientList);

		Shark.set({
			clientList,
			filteredClientList,
			__clientFilterActiveCSSClass: searchKey === "" ? "" : "active-filter",
			__visibleClientCount: visibleItemCount,
		});
	}

	init () {
		this.addComponents([activeWorkSessionDisplayComponent, clientDetailPanelComponent, mainNavComponent, waitBoxComponent, workSessionDetailsModalComponent]);

		const clientViewFilters = Shark.getInstance("__smart__", {
			clientSearchKey: "",
			onClientSearchKeyChanged: () => {
				clientListView.filterClients(clientViewFilters.clientSearchKey);
			},
		});

		Shark.set({
			clientList: [],
			clientViewFilters,
			__visibleClientCount: 0,
		});
	}

	getClientsByOrganization () {
		const { clientList, organizationList } = Shark.get();
		const clientByOrganization = {};

		const organizationMap = new Map();
		
		clientList.forEach(item => {
			const organizationGuid = item.organizationGuid;
			const organization = organizationList.find(organization => organization.guid === organizationGuid);

			if(organization) {
				organizationMap.set(organizationGuid, organization);
				if(clientByOrganization[organizationGuid]) {
					clientByOrganization[organizationGuid].push(item);
				}
				else {
					clientByOrganization[organizationGuid] = [item];
				}
			}
		});

		const clientsByOrganizationList = Object.entries(clientByOrganization).map(item => {
			return {
				organization: organizationMap.get(item[0]),
				clientList: item[1],
			};
		});

		// console.log(clientsByOrganizationList);

		Shark.set({
			clientsByOrganizationList,
		});
	}
	
	matchClientsAndOrganization () {
		const { organizationList, clientList } = Shark.get();

		if (organizationList && clientList && organizationList.length > 0 && clientList.length > 0) {
			const organizationMap = new Map();

			organizationList.forEach(item => {
				organizationMap.set(item.guid, item);
			});

			clientList.forEach(client => {
				if (organizationMap.has(client.organizationGuid)) {
					client.__organizationLabel = organizationMap.get(client.organizationGuid).name;
				}

				if (client.paymentCalculationType === 1) {
					client.__isFixedHoulyRate = true;
				}
				else if (client.paymentCalculationType === 2) {
					client.__isUserHourlyRate = true;
				}
				else if (client.paymentCalculationType === 3) {
					client.__isQuotation = true;
				}
			});

			Shark.set({
				clientList,
			});
		}
	}

	refreshClientList () {
		waitBoxComponent.open();

		clientManager.getList()
		.then(() => {
			const { clientList } = Shark.get();
			// console.log(clientList);
			Utils.reindexList(clientList);
			
			Shark.set({
				clientList,
				filteredClientList: clientList,
				__visibleClientCount: clientList.length,
			});
			
			this.matchClientsAndOrganization();
			this.getClientsByOrganization();
			
			waitBoxComponent.close();
			Shark.render();
		});
	}

	refreshClientListBtn_clickHandler () {
		this.refreshClientList();
	}

	updateMenuTitle () {
		Shark.set({
			__menuTitle: Shark.$store.labels.customer_list,
		});
	}
}

const clientListView = new ClientListView();

Shark.registerView(clientListView);

export default clientListView;
